import { getLoginPath } from '../../utils/loginEntry'
import { login } from '../../api/system'
import { getLoginUser, updateLoginUserAvatar } from '../../api/user'
import { TOKEN } from '../../constant/index'
import { setItem, getItem, removeItem } from '../../utils/cookie'
import { markLoginActivity, startIdleSession, stopIdleSession } from '../../utils/idleSession'
import { resetRouter } from '../../router'

const user = {
  namespaced: true,
  state: {
    // 用户token
    token: getItem(TOKEN),
    // 用户角色
    roles: '',
    // 登录用户名
    username: '',
    // 用户头像
    avatar: '',
    // 用户昵称
    nickname: '',
    // 登录时间
    loginTime: '',
    // 登录IP
    ipAddress: '',
    // IP属地
    ipLocation: ''
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_ROLES (state, roles) {
      state.roles = roles
    },
    SET_USERNAME (state, username) {
      state.username = username || ''
    },
    SET_AVATAR (state, avatar) {
      state.avatar = avatar
    },
    SET_NICK (state, nickname) {
      state.nickname = nickname
    },
    SET_LOGIN_TIME (state, loginTime) {
      state.loginTime = loginTime
    },
    SET_IP_ADDRESS (state, ipAddress) {
      state.ipAddress = ipAddress
    },
    SET_IP_LOCATION (state, ipLocation) {
      state.ipLocation = ipLocation
    }
  },
  // 异步处理方式
  actions: {
    /**
     * 用户登录
     */
    login ({ commit, dispatch }, loginForm) {
      // 登录页可能在同一个浏览器内切换账号，先清理上一个账号注入的路由和菜单。
      resetRouter()
      dispatch('permission/resetRoutes', null, { root: true })
      commit('app/CLOSE_ALL_TAGS', null, { root: true })
      commit('SET_ROLES', '')
      commit('SET_USERNAME', '')
      // 获取到用户参数
      const { username, password, code, traceId, channel, target } = loginForm
      // 调用登录方法，在获取到数据后向外传递
      return new Promise((resolve, reject) => {
        login({ username, password, code, traceId, channel, target }).then((data) => {
          // 设置token值
          commit('SET_TOKEN', data)
          setItem(TOKEN, data)
          markLoginActivity()
          resolve()
        }).catch((error) => {
          // 如果出现登录异常的情况将其捕获并抛出
          reject(error)
        })
      })
    },
    /**
     * 获取用户信息
     */
    getUserInfo ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        // 获取用户信息
        getLoginUser().then(res => {
          // 存储用户信息
          const user = res
          const avatar = (user.avatar === '' || user.avatar === null) ? '/default-avatar.jpg' : user.avatar
          commit('SET_AVATAR', avatar)
          // 设置当前用户角色到Vuex中
          commit('SET_ROLES', user.roles)
          // 保存账号名，用于客户侧业务编号前缀
          commit('SET_USERNAME', user.username)
          // 设置当前用户昵称到Vuex中
          commit('SET_NICK', user.nickname)
          // 设置登录时间
          commit('SET_LOGIN_TIME', user.loginTime)
          // 设置登录IP
          commit('SET_IP_ADDRESS', user.ipAddress)
          // 设置IP属地
          commit('SET_IP_LOCATION', user.ipLocation)
          startIdleSession(user.idleLogoutMinutes, () => {
            dispatch('logout').then(() => {
              window.location.replace(getLoginPath())
            })
          })
          resolve(user)
        }).catch((error) => {
          // 如果出现登录异常的情况将其捕获并抛出
          reject(error)
        })
      })
    },
    /**
     * 更新用户头像
     *
     * @param {*} param0
     * @param {*} avatarForm 用户头像表单
     */
    updateAvatar ({ commit }, avatarForm) {
      return new Promise((resolve, reject) => {
        // 更新用户头像信息
        const { userId, src } = avatarForm
        updateLoginUserAvatar({ userId, src }).then((res) => {
          // 更新用户头像（返回内容为用户新头像的访问路径）
          commit('SET_AVATAR', res)
          resolve(res)
        }).catch((error) => {
        // 如果出现更新异常的情况将其捕获并抛出
          reject(error)
        })
      })
    },
    /**
     * 退出登录
     *
     * @param {*} param0
     */
    logout ({ commit, dispatch }) {
      // 清除Token
      removeItem(TOKEN)
      commit('SET_TOKEN', null)
      stopIdleSession()
      // 清除当前账号注入的路由、侧栏和页面缓存，避免下一个账号复用。
      resetRouter()
      dispatch('permission/resetRoutes', null, { root: true })
      commit('app/CLOSE_ALL_TAGS', null, { root: true })
      commit('SET_ROLES', '')
      commit('SET_USERNAME', '')
      commit('SET_AVATAR', '')
      commit('SET_NICK', '')
      commit('SET_LOGIN_TIME', '')
      commit('SET_IP_ADDRESS', '')
      commit('SET_IP_LOCATION', '')
    }
  }
}

export default user
